import { useState } from 'react';

const PROMO_CODE = 'bank100';

const PromoCard = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(PROMO_CODE);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-card border border-border rounded-xl px-4 py-3 shadow-md w-52 flex flex-col gap-2">
      <div className="flex items-center gap-1.5">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-primary" />
        </span>
        <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">
          Limited offer
        </span>
      </div>

      <div>
        <p className="text-xs text-muted-foreground">First 500 customers</p>
        <p className="text-2xl font-extrabold text-foreground leading-tight">50% OFF</p>
      </div>

      <button
        onClick={handleCopy}
        className="w-full rounded-lg border border-primary/30 bg-primary/10 hover:bg-primary/20 transition-colors px-3 py-1.5 text-xs font-semibold text-primary"
      >
        {copied ? '✓ Copied!' : `Code: ${PROMO_CODE}`}
      </button>
    </div>
  );
};

export default PromoCard;
